const Thanks = () => {
    return (
        <div className="Thanks">
            <h1 className="Thanks__Title">¡Muchas gracias!</h1>
            <p className="Thanks__Subtitle Thanks__Text--Center">Tu apoyo es muy valioso para nosotr@s</p>
            <p className="Thanks__Icon"><i className="bi bi-chat-square-heart"></i></p>
            <p className="Thanks__Subtitle Thanks__Text--Center">Agradecemos tu participación</p>
            <p className="Thanks__Text">Nos vemos en la próxima dinámica que tenemos preparada para ti</p>
        </div>
    )
}

export { Thanks };